import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'groupFilterPaperflow'
})
export class GroupFilterPaperflowPipe implements PipeTransform {

  transform(value, temp: any) {

    let args = temp.split('|');
    let hrStatus = args[0].split(',');
    let matchType = args[1].split(',');
    if (this.checkEmpty(hrStatus) && this.checkEmpty(matchType)) {
      return value;
    }
    return value.filter((item) => {
      return this.ifExist(matchType, item.typeOfMatch) !== -1 &&
        this.ifExist(hrStatus, item.verificationResults) !== -1;
    });
  }

  checkEmpty(item) {
    if (item.toString().trim() === '') {
      return true;
    }
    return false;
  }

  ifExist(args, item) {
    for (let i = 0; i < args.length; i++) {
      args[i] = args[i].trim();
    }
    if (item === null) {
      if (item.trim() === '') {
        return -1;
      }
    }
    if (this.checkEmpty(args)) {
      return 0;
    }
    return args.indexOf(item.trim());
  }

}



// WEBPACK FOOTER //
// ./src/app/pipes/group-filter-paperflow.pipe.ts